import React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import SupportButton from './communication/SupportButton';

type TabKey = 'home' | 'profile';

const tabDefinitions: Array<{
  key: TabKey;
  label: string;
  icon: React.ReactNode;
  activeIcon?: React.ReactNode;
  path: string;
}> = [
  {
    key: 'home',
    label: 'Home',
    path: '/home',
    icon: (
      <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 20 20">
        <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" />
      </svg>
    )
  },
  {
    key: 'profile',
    label: 'Profile',
    path: '/home/profile',
    icon: (
      <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
      </svg>
    )
  }
];

const determineActiveTab = (pathname: string): TabKey => {
  const normalized = pathname.replace(/\/+$/, '');
  if (normalized.startsWith('/home/profile')) {
    return 'profile';
  }
  return 'home';
};

export const HomePage: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const activeTab = determineActiveTab(location.pathname);
  const normalizedPath = location.pathname.replace(/\/+$/, '');
  const showChrome = normalizedPath === '/home' || normalizedPath === '';

  const handleTabClick = (path: string) => {
    if (location.pathname === path) return;
    navigate(path);
  };

  return (
    <div className="flex h-screen flex-col overflow-hidden bg-[#FEF6D6]">
      {/*showChrome && (
        <header className="bg-[#2C2731] shadow-sm">
          <div className="mx-auto flex max-w-sm justify-center px-4 py-3">
            <img src="/gclogo.webp" alt="Guides Collective" className="h-10 w-auto" />
          </div>
        </header>
      )*/}

      <main className="flex-1 min-h-0 overflow-hidden">
        <Outlet />
      </main>

      {showChrome && <SupportButton />}

      {showChrome && (
        <nav className="sticky bottom-0 left-0 right-0 border-t border-[#FEF6D6]/40 bg-[#304031]">
          <div className="mx-auto max-w-sm px-4 py-2">
            <div className="flex justify-around">
              {tabDefinitions.map((tab) => {
                const isActive = activeTab === tab.key;
                return (
                  <button
                    key={tab.key}
                    type="button"
                    onClick={() => handleTabClick(tab.path)}
                    className={`relative flex flex-col items-center px-3 py-2 transition-colors ${
                      isActive ? 'text-[#FEF6D6]' : 'text-[#FEF6D6]/60'
                    }`}
                  >
                    <span className={`mb-1 ${isActive ? 'text-[#FEF6D6]' : 'text-[#FEF6D6]/60'}`}>
                      {tab.icon}
                    </span>
                    <span
                      className={`text-xs ${
                        isActive ? 'font-medium text-[#FEF6D6]' : 'text-[#FEF6D6]/60'
                      }`}
                    >
                      {tab.label}
                    </span>
                  </button>
                );
              })}
            </div>
          </div>
        </nav>
      )}
    </div>
  );
};

export default HomePage;
